<template>
  <DateFilter @filter="onFilter" @clear="onClear" />
</template>
<script>
import {EventNames} from "@/plugins/enums";
import DateFilter from '@/components/shared/Filters/Date-filter.vue'

export default {
    name: 'KarinDate',

    components: {
        DateFilter
    },

    methods: {
        onClear() {
            this.$eventBus.$emit(EventNames.ClearFilterKarinDenounce);
        },

        onFilter(interval) {
            this.$eventBus.$emit(EventNames.FilterKarinDenounceByDate, interval);
        }
    }
}
</script>